import JobActions from './styled';

export default JobActions;
